import {https, httpsFile} from './http.js';

export function index(page, currentpage,sortby,sortdir, search,status, supplier, startDate,endDate,plant,search_item) {
    return httpsFile().get(`goods_receipt?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&search_item=${search_item}&status=${status}&supplier=${supplier}&startDate=${startDate}&endDate=${endDate}&plant=${plant}`);
}

export function show(id,show){
    return https().get(`goods_receipt/${id}?showFor=${show}`);
}

export function showReceivingReport(page, currentpage,sortby,sortdir, search,status, supplier, startDate,endDate,filterPlant) {
    return httpsFile().get(`showReceivingReport?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}
    &search=${search}&status=${status}&supplier=${supplier}&startDate=${startDate}&endDate=${endDate}&filterPlant=${filterPlant}`);
}

export function showReceivingReportDetails(id){
    return https().get(`showReceivingReport/${id}`);
}

export function receiveGoods(data){
    return https().post(`receiveGoods`,data);
}

export function getDelivered(MATNR,EBELN,EBELP){
    return https().get(`getDelivered?MATNR=${MATNR}&EBELN=${EBELN}&EBELP=${EBELP}`);
}
export function getStatus(EBELN){
    return https().get(`getStatus?EBELN=${EBELN}`);
}

export function getRequestedQty(MATNR,EBELN){
    return https().get(`getRequestedQty?MATNR=${MATNR}&EBELN=${EBELN}`);
}

export function xmlExport(data){
    return https().post(`xmlExport`,data);
}
export function cancelSelectedGR(data){
    return https().post(`cancelSelectedGR`,data);
}

export function saveReceivingReport(data){
    return https().post(`saveReceivingReport`,data);
}

export function manualExport(id){
    return https().get(`goodsReceiptManualExport?id=${id}`);
}
export function discardRequest(id){
    return https().get(`goodsReceiptDiscardRequest?id=${id}`);
}